<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div fxLayout="column" id="itemRecordContainer">
  <record-text [text]="record.displayedText"></record-text>
  <div
    fxLayout="row"
    *ngFor="let option of record.options; let i = index"
    id="recordCheckboxesContainer"
  >
    <record-icon-text
      [text]="option.optionText"
      [icon]="option.isSelected ? faCheckSquare : faSquare"
    ></record-icon-text>
  </div>
</div>
